import React from "react";
import ExpensesContainer from "../../containers/Expenses";

function Expenses(props) {
  return <ExpensesContainer {...props} />;
}

export default Expenses;
